import { render } from "./smanage.vue?vue&type=template&id=791a5eb2&scoped=true"
const script = {}

import "./smanage.vue?vue&type=style&index=0&id=791a5eb2&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791a5eb2"]])

export default __exports__